export default {
  apiKey: 'AIzaSyCAXSuqSTBqGTRjnxik0cBP0fJmLf0Mk_o',
  authDomain: 'lessonize-staging.firebaseapp.com',
  databaseURL: 'https://lessonize-staging.firebaseio.com',
  projectId: 'lessonize-staging',
  storageBucket: 'lessonize-staging.appspot.com',
  messagingSenderId: '1012563856477',
  appId: '1:1012563856477:web:3755c2beabd449171e11b4',
};
